module.exports = __webpack_public_path__ + "static/media/YF88_2.8295471f.jpg";